/**
 * Сервис для работы с API service-types.
 * Единый источник данных о доступных модулях системы.
 */
import authService from './auth.service';
import type { ServiceType } from '../types/serviceType';

const API_BASE = '/api/v1/service-types';

/**
 * Получить список типов сервисов.
 * @param filterByProfile - фильтровать по COMPOSE_PROFILES (default: true)
 */
async function list(filterByProfile = true): Promise<ServiceType[]> {
  const url = `${API_BASE}?filter_by_profile=${filterByProfile}`;
  const resp = await authService.fetchWithAuth(url);
  if (!resp.ok) {
    throw new Error(`Failed to fetch service types: ${resp.status}`);
  }
  return resp.json();
}

/**
 * Получить только активные типы сервисов для текущего пользователя.
 */
async function getEnabled(): Promise<ServiceType[]> {
  return list(true);
}

/**
 * Получить все активные типы сервисов (без фильтрации по профилю).
 */
async function getAll(): Promise<ServiceType[]> {
  return list(false);
}

export const serviceTypeService = {
  list,
  getEnabled,
  getAll,
};
